import { render, staticRenderFns } from "./NoticeForUse.vue?vue&type=template&id=0c3fc8a9&scoped=true&"
import script from "./NoticeForUse.vue?vue&type=script&lang=js&"
export * from "./NoticeForUse.vue?vue&type=script&lang=js&"
import style0 from "./NoticeForUse.vue?vue&type=style&index=0&id=0c3fc8a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fc8a9",
  null
  
)

export default component.exports